/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  customElements.whenDefined("hover-disclosure").then(function () {
    var proto = customElements.get("hover-disclosure").prototype;

    function syncState(el) {
      var trigger = el.querySelector("[data-top-link]");
      if (trigger && trigger.hasAttribute("aria-controls")) {
        trigger.setAttribute("aria-expanded", el.classList.contains("is-visible"));
      }
      el.removeAttribute("aria-expanded");
      el.removeAttribute("aria-haspopup");
    }

    ["showDisclosure", "hideDisclosure"].forEach(function (name) {
      var original = proto[name];
      proto[name] = function () {
        original.apply(this, arguments);
        syncState(this);
      };
    });

    document.querySelectorAll("hover-disclosure").forEach(syncState);

    document.addEventListener("keydown", function (evt) {
      if (evt.key !== "Enter" && evt.key !== " ") {
        return;
      }
      var trigger = evt.target.closest("[data-top-link][role='button']");
      var el = trigger && trigger.closest("hover-disclosure");
      if (!el) {
        return;
      }
      evt.preventDefault();
      if (el.classList.contains("is-visible")) {
        el.hideDisclosure();
      } else {
        el.showDisclosure();
      }
    });
  });

  document.addEventListener("DOMContentLoaded", function () {

    //PDP custom — White Glove Assembly toggle.
    // Delegated on document (capture phase) so it survives <product-info> re-renders after a
    // variant change. Must be capture, not bubble: the handler's own targetLabel.click() below
    // triggers <variant-selects>'s AJAX re-render synchronously, which detaches the checkbox
    // mid-dispatch and silently kills the outer event's remaining bubble propagation before it
    // reaches document — capture runs top-down before that happens, so it isn't affected.
    document.addEventListener("change", function (event) {
      const toggleCheckbox = event.target;
      if (!toggleCheckbox || toggleCheckbox.id !== "toggle-checkbox") return;
      const targetLabel = document.querySelector(
        toggleCheckbox.checked ? "#assembly-toggle-2" : "#assembly-toggle-1"
      );
      if (targetLabel) targetLabel.click();
    }, true);

    //Navigation Redesign
    document.querySelectorAll(".second-level-links").forEach((link) => {
      link.addEventListener("click", function (event) {
        event.stopPropagation();

        if (link.classList.contains("third-level-open")) {
          link.classList.remove("third-level-open");
        } else {
          document
            .querySelectorAll(".second-level-links.third-level-open")
            .forEach((otherLink) => {
              otherLink.classList.remove("third-level-open");
            });

          link.classList.add("third-level-open");
        }
      });
    });

    document.querySelectorAll(".header__menu .menu__item").forEach((item) => {
      const closeButton = item.querySelector(".nav-close");
      const dropdown = item.querySelector(".header__dropdown");
      const trigger = item.querySelector("[data-top-link]");

      if (dropdown) {
        const closeDropdown = () => {
          dropdown.classList.remove("is-visible");
          document.body.classList.remove("no-scroll");
          if (trigger) {
            trigger.setAttribute("aria-expanded", "false");
          }

          item
            .querySelectorAll(".navlink--child.links-level")
            .forEach((link) => {
              link.classList.remove("nav-active");
              link.setAttribute("aria-expanded", "false");
            });
          item.querySelectorAll(".grandchildren-nav").forEach((nav) => {
            nav.classList.remove("nav-visible");
          });
          item.querySelectorAll(".grandchildren-wrapper").forEach((wrap) => {
            wrap.classList.remove("nav-show");
          });
        };

        item.addEventListener("click", function () {
          document
            .querySelectorAll(".header__menu .menu__item .header__dropdown")
            .forEach((otherDropdown) => {
              otherDropdown.classList.remove("is-visible");
            });
          document
            .querySelectorAll(".header__menu .menu__item [data-top-link]")
            .forEach((otherTrigger) => {
              otherTrigger.setAttribute("aria-expanded", "false");
            });

          document.body.classList.remove("no-scroll");
          dropdown.classList.toggle("is-visible");

          const isOpen = dropdown.classList.contains("is-visible");
          if (trigger) {
            trigger.setAttribute("aria-expanded", isOpen.toString());
          }
          if (isOpen) {
            document.body.classList.add("no-scroll");
          }
        });

        item.addEventListener("keydown", function (event) {
          if (
            event.key === "Escape" &&
            dropdown.classList.contains("is-visible")
          ) {
            closeDropdown();
            if (trigger) {
              trigger.focus();
            }
          }
        });

        item.addEventListener("focusout", function (event) {
          if (!item.contains(event.relatedTarget)) {
            closeDropdown();
          }
        });

        if (closeButton) {
          closeButton.addEventListener("click", function (event) {
            event.stopPropagation();
            closeDropdown();
          });
        }
      }

      item
        .querySelectorAll(".navlink--child.links-level .navtext")
        .forEach((navText) => {
          const levelLink = navText.parentElement;
          levelLink.addEventListener("click", function (event) {
            document
              .querySelectorAll(".navlink--child.links-level")
              .forEach((nav) => {
                nav.classList.remove("nav-active");
                nav.setAttribute("aria-expanded", "false");
              });
            levelLink.classList.add("nav-active");

            const clickedText = navText.textContent.trim();
            const targetNav = document.querySelector(
              `.grandchildren-nav[data-id="${clickedText}"]`,
            );

            if (targetNav) {
              document.querySelectorAll(".grandchildren-nav").forEach((nav) => {
                nav.classList.remove("nav-visible");
                nav.parentElement.classList.add("nav-show");
              });

              targetNav.classList.toggle("nav-visible");
              levelLink.setAttribute(
                "aria-expanded",
                targetNav.classList.contains("nav-visible").toString(),
              );
            }
          });
        });
    });

    // Recipe World Cup — round filter pills on the bracket tournament page.
    const bracketContainer = document.querySelector(".bracket-tournament");
    if (bracketContainer) {
      const filterPills = bracketContainer.querySelectorAll(".bracket-pill");
      const roundSections = bracketContainer.querySelectorAll(
        ".bracket-round-section",
      );

      function activateRound(targetRound) {
        filterPills.forEach((p) => {
          const active = p.getAttribute("data-round") === targetRound;
          p.classList.toggle("is-active", active);
          p.setAttribute("aria-pressed", active ? "true" : "false");
        });
        roundSections.forEach((section) => {
          if (section.getAttribute("data-round") === targetRound) {
            section.classList.add("is-active");
          } else {
            section.classList.remove("is-active");
          }
        });
      }

      filterPills.forEach((pill) => {
        pill.addEventListener("click", function () {
          activateRound(this.getAttribute("data-round"));
        });
      });

      // Bracket-tree cells link to recipe cards inside round sections that are
      // hidden until their pill is active. Activate the matching round first,
      // then scroll the card into view.
      bracketContainer
        .querySelectorAll("a.bracket-cell")
        .forEach((cell) => {
          cell.addEventListener("click", function (e) {
            const href = this.getAttribute("href") || "";
            const m = href.match(/^#bracket-card-([^-]+)-/);
            if (!m) return;
            e.preventDefault();
            activateRound(m[1]);
            const target = bracketContainer.querySelector(href);
            if (target) {
              target.scrollIntoView({ behavior: "smooth", block: "start" });
            }
            if (history.replaceState) {
              history.replaceState(null, "", href);
            }
          });
        });
    }
  });

  // Theme adds its keyboard-focus class (is-focused) only on Tab, not Escape,
  // so an Escape-closed dialog refocuses its trigger with no ring. Flag it too.
  document.addEventListener(
    "keydown",
    function (event) {
      if (event.key === "Escape") {
        document.body.classList.add("is-focused");
      }
    },
    true,
  );

  // Return focus to the search trigger on close (the theme doesn't). Watching
  // is-open covers Escape, the close button, and click-outside.
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("header-search-popdown").forEach(function (popdown) {
      const summary = popdown.querySelector("summary");
      if (!summary) return;
      let wasOpen = popdown.classList.contains("is-open");
      new MutationObserver(function () {
        const isOpen = popdown.classList.contains("is-open");
        if (wasOpen && !isOpen && popdown.contains(document.activeElement)) {
          summary.focus();
        }
        wasOpen = isOpen;
      }).observe(popdown, { attributes: true, attributeFilter: ["class"] });
    });
  });

  // The theme traps focus in the cart natively once its open animation fires
  // (see custom.css). It only misses aria-modal — toggle that with open state.
  document.addEventListener("DOMContentLoaded", function () {
    const cartDrawer = document.getElementById("cart-drawer");
    if (!cartDrawer) return;

    const syncAriaModal = function () {
      if (cartDrawer.classList.contains("is-open")) {
        cartDrawer.setAttribute("aria-modal", "true");
      } else {
        cartDrawer.removeAttribute("aria-modal");
      }
    };

    syncAriaModal();
    new MutationObserver(syncAriaModal).observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  });

  // Announce collection filter results to screen readers (AMP122). The filter
  // form swaps [data-products-grid] innerHTML without moving focus, so the
  // result count or no-results message is otherwise silent. Mirror it into a
  // persistent role="status" region.
  document.querySelectorAll("[data-products-grid]").forEach(function (grid) {
    var status = grid.parentElement.querySelector("[data-products-status]");
    if (!status) return;

    new MutationObserver(function () {
      var noResults = grid.querySelector(".no-results");
      var source = noResults ? noResults.querySelector("p") || noResults : grid.querySelector("[data-results-summary]");
      var message = source ? source.textContent.trim() : "";
      if (status.textContent !== message) {
        status.textContent = message;
      }
    }).observe(grid, { childList: true, subtree: true });
  });

  document.querySelectorAll("[data-collection-sidebar]").forEach(function (sidebar) {
    var focusedSelector = null;

    sidebar.addEventListener("focusin", function (e) {
      var el = e.target;
      if (el.id) focusedSelector = "#" + CSS.escape(el.id);
      else if (el.hasAttribute("data-range-left")) focusedSelector = "[data-range-left]";
      else if (el.hasAttribute("data-range-right")) focusedSelector = "[data-range-right]";
      else focusedSelector = null;
    });

    new MutationObserver(function () {
      if (focusedSelector && document.activeElement === document.body) {
        var next = sidebar.querySelector(focusedSelector);
        if (next) next.focus();
      }
    }).observe(sidebar, { childList: true });
  });

  // WAI-ARIA tablist keyboard navigation for section-tab-collections (AMP29).
  // The theme's GlobalTabs handles click/Enter/Space activation but has no
  // arrow-key support and never syncs aria-selected/tabindex. This patch adds
  // both, scoped only to [role="tablist"] inside [data-tabs-holder].
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('[data-tabs-holder] [role="tablist"]').forEach(function (tablist) {
      function getTabs() {
        return Array.from(tablist.querySelectorAll('[role="tab"]'));
      }

      function activateTab(tab) {
        getTabs().forEach(function (t) {
          const isSelected = t === tab;
          t.setAttribute("aria-selected", isSelected ? "true" : "false");
          t.setAttribute("tabindex", isSelected ? "0" : "-1");
        });
        tab.focus();
      }

      // Sync ARIA on every tab-change the theme fires (click, Space, Enter,
      // or Shopify block-select all route through theme:tab:change).
      tablist.closest("[data-tabs-holder]").addEventListener("theme:tab:change", function () {
        getTabs().forEach(function (t) {
          const isSelected = t.classList.contains("current");
          t.setAttribute("aria-selected", isSelected ? "true" : "false");
          t.setAttribute("tabindex", isSelected ? "0" : "-1");
        });
      });

      tablist.addEventListener("keydown", function (e) {
        const tabs = getTabs();
        const idx = tabs.indexOf(document.activeElement);
        if (idx === -1) return;

        let next = -1;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") {
          next = (idx + 1) % tabs.length;
        } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
          next = (idx - 1 + tabs.length) % tabs.length;
        } else if (e.key === "Home") {
          next = 0;
        } else if (e.key === "End") {
          next = tabs.length - 1;
        }

        if (next !== -1) {
          e.preventDefault();
          tabs[next].click();
          activateTab(tabs[next]);
        }
      });
    });
  });

  document.addEventListener("click", function (e) {
    var toggle = e.target.closest('button[aria-controls="filter-groups"]');
    if (!toggle) return;
    setTimeout(function () {
      if (toggle.getAttribute("aria-expanded") !== "true") return;
      var first = Array.from(
        document.querySelectorAll("#filter-groups summary, #filter-groups a[href]")
      ).find(function (el) {
        return el.offsetParent !== null;
      });
      if (first) first.focus();
    }, 300);
  });

  var lastFilterFocusId;
  var lastFilterFocusWasChip;
  document.addEventListener("focusin", function (e) {
    var inFilters = !!e.target.closest("#filter-groups");
    lastFilterFocusId = inFilters ? e.target.id : null;
    lastFilterFocusWasChip = inFilters && !!e.target.closest(".active__filters__remove");
  });
  document.addEventListener("pointerdown", function (e) {
    if (!e.target.closest("#filter-groups")) {
      lastFilterFocusId = null;
      lastFilterFocusWasChip = false;
    }
  });
  new MutationObserver(function () {
    if (document.activeElement !== document.body) return;
    var el = lastFilterFocusId && document.getElementById(lastFilterFocusId);
    if (!el && lastFilterFocusWasChip) {
      el = document.querySelector("#filter-groups summary");
    }
    if (el && el.closest("#filter-groups")) el.focus();
  }).observe(document.body, { childList: true, subtree: true });

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      var toggle = record.target;
      if (
        !toggle.matches('button[aria-controls="filter-groups"]') ||
        toggle.getAttribute("aria-expanded") !== "false"
      ) {
        return;
      }
      var active = document.activeElement;
      if (active === document.body || active.closest("#filter-groups")) toggle.focus();
    });
  }).observe(document.body, {
    attributes: true,
    attributeFilter: ["aria-expanded"],
    subtree: true,
  });

  document.addEventListener(
    "change",
    function (e) {
      var input = e.target;
      if (!input.matches("[data-field-price-min], [data-field-price-max]")) return;
      var value = parseFloat(input.value);
      if (isNaN(value)) return;
      input.value = Math.min(Math.max(value, parseFloat(input.min)), parseFloat(input.max));
    },
    true
  );

  // Slick Carousel assigns role="listbox" to its track element but never an
  // accessible name, failing aria-input-field-name. Label each track once
  // Slick has initialized it; a MutationObserver covers lazy-loaded sliders
  // that mount after DOMContentLoaded.
  document.addEventListener("DOMContentLoaded", function () {
    function labelSlickTracks(root) {
      root.querySelectorAll('.slick-track[role="listbox"]:not([aria-label])').forEach(function (track) {
        track.setAttribute("aria-label", "Image carousel");
      });
    }

    labelSlickTracks(document);
    new MutationObserver(function () {
      labelSlickTracks(document);
    }).observe(document.body, { childList: true, subtree: true });
  });

  // RecipeKit's app block emits VideoObject.uploadDate as a bare date, which
  // Google rejects as an invalid datetime. Promote it to a full ISO 8601 value.
  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll('script[type="application/ld+json"]')
      .forEach(function (node) {
        var data;
        try {
          data = JSON.parse(node.textContent);
        } catch (e) {
          return;
        }
        var uploadDate = data && data.video && data.video.uploadDate;
        if (typeof uploadDate !== "string") return;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(uploadDate)) return;
        data.video.uploadDate = uploadDate + "T12:00:00Z";
        node.textContent = JSON.stringify(data);
      });
  });

  // Announcement bar scrolling text: dispatch the theme:ticker:refresh
  // announcement.js misses and slow the scroll to 40px/s. On mobile, park the
  // hidden tickers and set the slider's dwell to one full marquee pass.
  (function () {
    const TICKER_SPEED = 2.5; // seconds per 100px of text (theme default 1.63)
    const MOBILE = window.matchMedia("(max-width: 749px)");
    const teardowns = [];

    function tickersIn(bar) {
      return Array.from(bar.querySelectorAll("ticker-bar"));
    }

    function measure(bar) {
      tickersIn(bar).forEach(function (ticker) {
        if (ticker.querySelector(".ticker--animated")) return;
        ticker.speed = TICKER_SPEED;
        ticker.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
      });
    }

    function restart(ticker) {
      ticker.removeAttribute("paused");
      const texts = ticker.querySelectorAll(".ticker--animated");
      texts.forEach(function (text) {
        text.classList.remove("ticker--animated");
      });
      void ticker.offsetWidth;
      texts.forEach(function (text) {
        text.classList.add("ticker--animated");
      });
      return texts[0] || null;
    }

    function sync(bar) {
      const flkty = (bar.querySelector("slider-component") || {}).flkty;
      const player = flkty && flkty.player;
      if (!player) return null;

      const dwell = player.autoPlay;

      function hold() {
        const selected = bar.querySelector(".announcement__slide.is-selected");
        tickersIn(bar).forEach(function (ticker) {
          if (ticker !== selected) ticker.setAttribute("paused", "");
        });
        const text = selected && restart(selected);
        const pass = text ? parseFloat(getComputedStyle(text).animationDuration) * 1000 : 0;
        player.autoPlay = pass || dwell;
        player.tick(); // re-arm with the new interval
      }

      flkty.on("select", hold);
      hold();

      return function () {
        flkty.off("select", hold);
        player.autoPlay = dwell;
        player.tick();
        tickersIn(bar).forEach(function (ticker) {
          ticker.removeAttribute("paused");
        });
      };
    }

    function apply() {
      const bars = document.querySelectorAll("announcement-bar");
      bars.forEach(measure);

      if (!MOBILE.matches) {
        teardowns.splice(0).forEach(function (teardown) {
          teardown();
        });
        return;
      }
      if (teardowns.length) return;
      bars.forEach(function (bar) {
        const teardown = sync(bar);
        if (teardown) teardowns.push(teardown);
      });
    }

    function schedule() {
      customElements.whenDefined("ticker-bar").then(function () {
        requestAnimationFrame(apply);
      });
    }

    document.addEventListener("theme:slider:loaded", function (event) {
      if (event.target.closest && event.target.closest("announcement-bar")) {
        schedule();
      }
    });

    document.addEventListener("DOMContentLoaded", schedule);
    window.addEventListener("load", schedule);
    MOBILE.addEventListener("change", schedule);
  })();

  // blocks/_panel.liquid's settings are opaque to the host section's block
  // loop (only .id resolves there), so it stashes title/image in data
  // attributes for us to copy into the nav link. The image clones a
  // <template> (real render 'image' markup, never fetched until cloned)
  // instead of rebuilding an <img> in JS. Also runs on shopify:section:load,
  // since a section added live in the editor never fires DOMContentLoaded.
  function syncPanelTabNav(scope) {
    scope.querySelectorAll("tabs-component .tab-content[data-tab-title]").forEach(function (tabContent) {
      var match = tabContent.className.match(/tab-content-(\d+)/);
      var title = tabContent.getAttribute("data-tab-title");
      if (!match || !title) return;

      var tabsComponent = tabContent.closest("tabs-component");
      var link = tabsComponent && tabsComponent.querySelector('[data-tab="' + match[1] + '"]');
      if (!link) return;

      var label = link.querySelector(".tab-nav-label");
      if (label) label.textContent = title;

      if (tabContent.getAttribute("data-has-tab-image") === "true" && !link.querySelector(".tab-link__image")) {
        var template = tabContent.querySelector("template[data-tab-image-template]");
        if (template) {
          var wrapper = document.createElement("span");
          wrapper.className = "tab-link__image";
          wrapper.appendChild(template.content.cloneNode(true));
          link.insertBefore(wrapper, link.firstChild);
          link.classList.add("tab-link--has-image");

          var tabsList = tabsComponent.querySelector(".tabs");
          if (tabsList) tabsList.classList.add("tabs--card-mode");
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    syncPanelTabNav(document);
  });

  document.addEventListener("shopify:section:load", function (e) {
    syncPanelTabNav(e.target);
  });

  // theme-editor.js only auto-opens a tab/panel when the SELECTED element
  // itself carries data-tab/data-collapsible — a nested block inside one
  // doesn't, so walk up to the enclosing .tab-content and open it instead.
  document.addEventListener("shopify:block:select", function (e) {
    var tabContent = e.target.closest(".tab-content");
    if (!tabContent) return;

    var tabsComponent = tabContent.closest("tabs-component");
    if (!tabsComponent) return;

    var match = tabContent.className.match(/tab-content-(\d+)/);
    if (!match) return;

    // Desktop: switch to this tab if another one is currently showing.
    var link = tabsComponent.querySelector('[data-tab="' + match[1] + '"]');
    if (link && !link.classList.contains("current")) {
      link.dispatchEvent(new Event("click"));
    }

    // Mobile: the same panel is also a collapsible accordion item. If it's
    // interactive (not desktop's forced-open/disabled state) and currently
    // closed, open it too.
    if (!tabContent.hasAttribute("disabled") && tabContent.getAttribute("open") !== "true") {
      tabContent.querySelector("[data-collapsible-trigger]")?.dispatchEvent(new Event("click"));
    }
  });
  // Fix DOM order after Flickity initializes. slider-component always appends its viewport
  // as the last child regardless of markup order, so the thumbnail row (already in the DOM)
  // ends up before it — breaking the theme's `.is-selected` lookup for thumb sync and
  // putting thumbnails before the image in Tab order. Move the row to the real last child
  // instead of faking order with CSS.
  (function () {
    function moveThumbsAfterViewport(slider) {
      if (slider.dataset.thumbsReordered) return;
      const thumbsWrapper = slider.querySelector(":scope > .gallery-slider__thumbs-wrapper");
      const viewport = slider.querySelector(":scope > .flickity-viewport");
      if (!thumbsWrapper || !viewport) return;

      slider.appendChild(thumbsWrapper);
      slider.dataset.thumbsReordered = "true";
    }

    function reorderAllGallerySliders() {
      document.querySelectorAll(".gallery-slider__slider.flickity-enabled").forEach(moveThumbsAfterViewport);
    }

    document.addEventListener("theme:slider:loaded", function (event) {
      if (event.target.closest && event.target.closest(".gallery-slider")) {
        reorderAllGallerySliders();
      }
    });
    document.addEventListener("DOMContentLoaded", reorderAllGallerySliders);
  })();

  // Keep the thumbnail row scrolled to the active slide. Rather than hooking every way a
  // slide can change (swipe, arrows, autoplay, thumbnail click), watch for Flickity
  // toggling `.is-selected`, the one signal common to all of them.
  (function () {
    function setupSync(slider) {
      if (slider.dataset.thumbsSyncBound) return;
      slider.dataset.thumbsSyncBound = "true";

      const thumbs = slider.querySelectorAll(".gallery-slider__thumb");
      if (!thumbs.length) return;

      // Flickity re-toggles `.is-selected` on resize (mobile browsers fire resize when the
      // address bar collapses/expands during scroll), not just on an actual slide change —
      // skip re-scrolling to the same index.
      let lastIndex = null;

      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          const slide = mutation.target;
          if (!slide.classList.contains("is-selected")) return;

          const index = slide.getAttribute("data-slide-index");
          if (index === null || index === lastIndex) return;
          lastIndex = index;

          const thumb = thumbs[Number(index)];
          if (thumb) {
            // scrollIntoView walks every scrollable ancestor, including the page itself —
            // on mobile this could hijack the page's own scroll position. Scroll only the
            // thumbnail track directly instead.
            const track = thumb.parentElement;
            const targetLeft = thumb.offsetLeft - (track.clientWidth - thumb.offsetWidth) / 2;
            track.scrollTo({ left: targetLeft, behavior: "smooth" });
          }
        });
      });

      slider.querySelectorAll("[data-slide]").forEach(function (slide) {
        observer.observe(slide, { attributes: true, attributeFilter: ["class"] });
      });
    }

    function setupAllSyncs() {
      document.querySelectorAll(".gallery-slider__slider.flickity-enabled").forEach(setupSync);
    }

    document.addEventListener("theme:slider:loaded", function (event) {
      if (event.target.closest && event.target.closest(".gallery-slider")) {
        setupAllSyncs();
      }
    });
    document.addEventListener("DOMContentLoaded", setupAllSyncs);
  })();

  // Thumbnail row scroll arrows. The track is a plain scrollable div, not a Flickity
  // instance, so scrolling and end-state need manual wiring.
  (function () {
    // Hide arrows entirely when nothing overflows — a permanently-disabled control is
    // unfocusable clutter.
    function updateArrows(track, prevBtn, nextBtn) {
      const overflows = track.scrollWidth > track.clientWidth + 1;

      if (prevBtn) {
        prevBtn.hidden = !overflows;
        prevBtn.disabled = track.scrollLeft <= 0;
      }
      if (nextBtn) {
        nextBtn.hidden = !overflows;
        nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      }
    }

    function setupThumbTrack(track) {
      const wrapper = track.closest(".gallery-slider__thumbs-wrapper");
      if (!wrapper) return;
      const prevBtn = wrapper.querySelector(".gallery-slider__thumbs-arrow--prev");
      const nextBtn = wrapper.querySelector(".gallery-slider__thumbs-arrow--next");

      if (!track.dataset.thumbsBound) {
        track.dataset.thumbsBound = "true";
        track.addEventListener("scroll", function () {
          updateArrows(track, prevBtn, nextBtn);
        }, { passive: true });
        window.addEventListener("resize", function () {
          updateArrows(track, prevBtn, nextBtn);
        });
      }

      updateArrows(track, prevBtn, nextBtn);
    }

    function setupAllThumbTracks() {
      document.querySelectorAll(".gallery-slider__thumbs").forEach(setupThumbTrack);
    }

    document.addEventListener("click", function (event) {
      const arrow = event.target.closest(".gallery-slider__thumbs-arrow");
      if (!arrow) return;

      const wrapper = arrow.closest(".gallery-slider__thumbs-wrapper");
      const track = wrapper && wrapper.querySelector(".gallery-slider__thumbs");
      if (!track) return;

      const amount = track.clientWidth * 0.8;
      track.scrollBy({
        left: arrow.classList.contains("gallery-slider__thumbs-arrow--prev") ? -amount : amount,
        behavior: "smooth",
      });
    });

    document.addEventListener("DOMContentLoaded", setupAllThumbTracks);
    document.addEventListener("theme:slider:loaded", setupAllThumbTracks);
  })();

  // Shared behavior for snippets/metaobject-grid.liquid ([data-entity-grid]): field-based
  // filtering (any [data-filter-field] select, with cascade via [data-depends-on]) and
  // "Show more" pagination over server-rendered cards. See docs/metaobject-grid.md.
  (function () {
    function getFilterSelects(grid) {
      return Array.from(grid.querySelectorAll("[data-filter-field]"));
    }

    function getFilterValues(grid) {
      const values = {};
      getFilterSelects(grid).forEach(function (select) {
        if (select.value) values[select.dataset.filterField] = select.value;
      });
      return values;
    }

    function matchesFilters(item, values) {
      return Object.keys(values).every(function (field) {
        return item.dataset[field] === values[field];
      });
    }

    // Populates every filter with no [data-depends-on] (e.g. Country) from all items.
    function populateIndependentFilters(grid, items) {
      getFilterSelects(grid).forEach(function (select) {
        if (select.dataset.dependsOn) return;

        const field = select.dataset.filterField;
        const options = Array.from(
          new Set(items.map(function (item) { return item.dataset[field]; }).filter(Boolean))
        ).sort();

        options.forEach(function (option) {
          const optionEl = document.createElement("option");
          optionEl.value = option;
          optionEl.textContent = option;
          select.appendChild(optionEl);
        });
      });
    }

    // Rebuilds options for filters depending on the field that just changed (e.g. State
    // on Country). Only rebuilds matching dependents, so an unrelated change doesn't
    // wipe out a dependent select's own current selection.
    function refreshDependentFilters(grid, items, changedField) {
      const values = getFilterValues(grid);
      getFilterSelects(grid).forEach(function (select) {
        const dependsOn = select.dataset.dependsOn;
        if (!dependsOn || dependsOn !== changedField) return;

        const field = select.dataset.filterField;
        const options = Array.from(
          new Set(
            items
              .filter(function (item) {
                return !values[dependsOn] || item.dataset[dependsOn] === values[dependsOn];
              })
              .map(function (item) {
                return item.dataset[field];
              })
              .filter(Boolean)
          )
        ).sort();

        select.innerHTML = '<option value="">' + (select.dataset.allLabel || "Any") + "</option>";
        options.forEach(function (option) {
          const optionEl = document.createElement("option");
          optionEl.value = option;
          optionEl.textContent = option;
          select.appendChild(optionEl);
        });
        select.disabled = options.length === 0;
      });
    }

    function render(grid, options) {
      const announce = options && options.announce;
      const items = Array.from(grid.querySelectorAll(".metaobject-grid__item"));
      const values = getFilterValues(grid);
      const initialCount = parseInt(grid.dataset.initialCount, 10) || 0;
      const revealed = parseInt(grid.dataset.revealed, 10) || initialCount || items.length;
      const loadMoreWrapper = grid.querySelector(".metaobject-grid__load-more");

      let visibleCount = 0;
      items.forEach(function (item) {
        const matches = matchesFilters(item, values);
        const withinLimit = !initialCount || visibleCount < revealed;
        item.classList.toggle("is-hidden", !matches || !withinLimit);
        if (matches) visibleCount += 1;
      });

      const matchingCount = items.filter(function (item) {
        return matchesFilters(item, values);
      }).length;

      if (loadMoreWrapper) {
        loadMoreWrapper.hidden = !initialCount || matchingCount <= revealed;
      }

      if (announce) {
        const status = grid.querySelector("[data-grid-status]");
        if (status) {
          const noun = grid.dataset.resultsNoun || "items";
          status.textContent = visibleCount + " " + noun + " shown";
        }
      }
    }

    function setupGrid(grid) {
      if (grid.dataset.entityGridBound) return;
      grid.dataset.entityGridBound = "true";

      const items = Array.from(grid.querySelectorAll(".metaobject-grid__item"));

      populateIndependentFilters(grid, items);

      // Guards against browsers restoring a stale <select> value for options added
      // dynamically after page parse.
      getFilterSelects(grid).forEach(function (select) {
        select.value = "";
      });

      getFilterSelects(grid).forEach(function (select) {
        select.addEventListener("change", function () {
          grid.dataset.revealed = grid.dataset.initialCount || items.length;
          refreshDependentFilters(grid, items, select.dataset.filterField);
          render(grid, { announce: true });
        });
      });

      const loadMoreBtn = grid.querySelector("[data-show-more]");
      if (loadMoreBtn) {
        loadMoreBtn.addEventListener("click", function () {
          const initialCount = parseInt(grid.dataset.initialCount, 10) || items.length;
          const revealed = parseInt(grid.dataset.revealed, 10) || initialCount;
          grid.dataset.revealed = revealed + initialCount;
          render(grid, { announce: true });
          // Only re-focus the button if it's still visible (more items left) — once the
          // wrapper hides, leave focus where it is rather than moving it to a vanished element.
          if (!loadMoreBtn.closest(".metaobject-grid__load-more").hidden) {
            loadMoreBtn.focus();
          }
        });
      }

      render(grid, { announce: false });
    }

    function setupAllGrids() {
      document.querySelectorAll("[data-entity-grid]").forEach(setupGrid);
    }

    document.addEventListener("DOMContentLoaded", setupAllGrids);
    document.addEventListener("shopify:section:load", setupAllGrids);
  })();

  // Patches GridSlider.getSlidesWidth() (theme.js): it ignores the margin-right gap between
  // items, which can misclassify an overflowing slider as "fits" and disable itself.
  (function () {
    customElements.whenDefined("grid-slider").then(function () {
      const GridSlider = customElements.get("grid-slider");

      GridSlider.prototype.getSlidesWidth = function () {
        const items = this.slider.querySelectorAll("[data-grid-item]");
        let total = 0;
        items.forEach(function (item) {
          const style = getComputedStyle(item);
          total += item.clientWidth + parseFloat(style.marginLeft || 0) + parseFloat(style.marginRight || 0);
        });
        return total;
      };

      function labelSlides(slider) {
        if (slider.getAttribute("aria-roledescription") !== "carousel") return;
        const items = slider.querySelectorAll("[data-grid-item]");
        items.forEach(function (item, i) {
          if (item.tagName === "LI") return;
          item.setAttribute("role", "group");
          item.setAttribute("aria-roledescription", "slide");
          item.setAttribute("aria-label", i + 1 + " of " + items.length);
        });
      }

      const init = GridSlider.prototype.init;
      GridSlider.prototype.init = function () {
        labelSlides(this);
        init.call(this);
      };
      document.querySelectorAll("grid-slider").forEach(labelSlides);

      // Re-run for instances already wrongly disabled by the buggy calculation before this
      // patch landed.
      document.querySelectorAll("grid-slider").forEach(function (el) {
        if (el.isInitialized || typeof el.toggleSlider !== "function") return;
        el.buttons = el.querySelectorAll("[data-button-arrow]");
        el.toggleSlider();
      });
    });
  })();

  document.querySelectorAll("[data-predictive-search-input]").forEach(function (input) {
    new MutationObserver(function () {
      var option = document.getElementById(input.getAttribute("aria-activedescendant"));
      if (option) option.scrollIntoView({ block: "nearest" });
    }).observe(input, { attributes: true, attributeFilter: ["aria-activedescendant"] });
  });
  
  (function () {
    function describeSlider(slider) {
      const flkty = slider.flkty;
      if (flkty) flkty.options.accessibility = false;
      slider.removeAttribute("tabindex");
      if (!flkty || slider.matches(".announcement__slider")) return;

      if (!slider.hasAttribute("role")) {
        slider.setAttribute("role", "group");
        slider.setAttribute("aria-roledescription", "carousel");
        slider.setAttribute("aria-label", "Slideshow");
      }
      const cells = flkty.getCellElements();
      cells.forEach(function (cell, i) {
        if (cell.hasAttribute("role")) return;
        cell.setAttribute("role", "group");
        cell.setAttribute("aria-roledescription", "slide");
        cell.setAttribute("aria-label", i + 1 + " of " + cells.length);
      });
      flkty.slider.setAttribute("aria-live", flkty.options.autoPlay ? "off" : "polite");
    }

    document.querySelectorAll("slider-component").forEach(describeSlider);
    document.addEventListener("theme:slider:loaded", function (e) {
      describeSlider(e.detail.slider);
    });
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
